import { NewsArticle } from "../types";

// Initial demo data for the news articles
const initialNewsArticles: NewsArticle[] = [
  {
    id: 1,
    title: "Νέα εργαλεία λογιστικής υποστήριξης",
    description: "Ανακαλύψτε τα νέα εργαλεία που θα διευκολύνουν τη λογιστική σας διαχείριση.",
    content: "Λεπτομερές περιεχόμενο για το άρθρο...",
    date: "10/07/2023",
    category: "news",
    image: "https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?q=80&w=300&auto=format&fit=crop",
    isPublic: true
  },
  {
    id: 2,
    title: "Επιδοτήσεις ΕΣΠΑ για επιχειρήσεις",
    description: "Νέο πρόγραμμα επιδοτήσεων για μικρομεσαίες επιχειρήσεις ανακοινώθηκε σήμερα.",
    content: "Λεπτομερές περιεχόμενο για το άρθρο...",
    date: "05/07/2023",
    category: "news",
    image: "https://images.unsplash.com/photo-1643057752896-b6fb4ee01bd9?q=80&w=300&auto=format&fit=crop",
    isPublic: true
  },
  {
    id: 3,
    title: "Αλλαγές στη φορολογική νομοθεσία",
    description: "Ενημερωθείτε για τις πρόσφατες αλλαγές στη φορολογική νομοθεσία που επηρεάζουν τις επιχειρήσεις.",
    content: "Λεπτομερές περιεχόμενο για το άρθρο...",
    date: "01/07/2023",
    category: "news",
    image: "https://images.unsplash.com/photo-1586094332066-fc72f8427986?q=80&w=300&auto=format&fit=crop",
    isPublic: true
  },
  {
    id: 4,
    title: "Νέες τεχνολογίες στη λογιστική",
    description: "Η τεχνητή νοημοσύνη αλλάζει τον τρόπο που γίνεται η λογιστική εργασία.",
    content: "Λεπτομερές περιεχόμενο για το άρθρο...",
    date: "15/06/2023",
    category: "tech",
    image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?q=80&w=300&auto=format&fit=crop",
    isPublic: true
  },
  {
    id: 5,
    title: "Blockchain στη λογιστική",
    description: "Πώς το blockchain μπορεί να φέρει επανάσταση στις λογιστικές διαδικασίες.",
    content: "Λεπτομερές περιεχόμενο για το άρθρο...",
    date: "10/06/2023",
    category: "tech",
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?q=80&w=300&auto=format&fit=crop",
    isPublic: true
  }
];

// Helper function to check if localStorage is available
const isLocalStorageAvailable = () => {
  try {
    const testKey = '__storage_test__';
    localStorage.setItem(testKey, testKey);
    localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    console.warn('localStorage is not available. News operations will be in-memory only.');
    return false;
  }
};

// In-memory fallback storage
let inMemoryNewsArticles: NewsArticle[] = [];

// Function to get stored articles or initialize with default data
export const getStoredArticles = (): NewsArticle[] => {
  if (!isLocalStorageAvailable()) {
    // If localStorage isn't available but we have in-memory data, use it
    if (inMemoryNewsArticles.length > 0) {
      return inMemoryNewsArticles;
    }
    // Otherwise use initial data
    inMemoryNewsArticles = [...initialNewsArticles];
    return inMemoryNewsArticles;
  }

  // Try to get from localStorage
  const storedArticles = localStorage.getItem('newsArticles');
  if (storedArticles) {
    try {
      const parsedArticles = JSON.parse(storedArticles);
      // Update in-memory backup
      inMemoryNewsArticles = parsedArticles;
      return parsedArticles;
    } catch (error) {
      console.error("Error parsing stored articles:", error);
      inMemoryNewsArticles = [...initialNewsArticles];
      return initialNewsArticles;
    }
  } else {
    inMemoryNewsArticles = [...initialNewsArticles];
    return initialNewsArticles;
  }
};

// Function to save articles
export const saveArticles = (articles: NewsArticle[]) => {
  // Update in-memory backup
  inMemoryNewsArticles = articles;
  
  // Try to save to localStorage if available
  if (isLocalStorageAvailable()) {
    try {
      localStorage.setItem('newsArticles', JSON.stringify(articles));
    } catch (error) {
      console.error("Error saving articles:", error);
    }
  }
};
